import { KnownOrderDtoStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useState } from 'react';
import { Modal } from '../../../../../ui/components/pure/modal/modal.component';
import { DeliverNowModalContent } from './components/deliver-now-modal-content';
import { DeliveryActionProps, useDeliveryAction } from './delivery-action.hook';

export function DeliveryActionModal(props: DeliveryActionProps) {
  const hook = useDeliveryAction(props);

  // Set the order status to a constant value
  const [orderStatus] = useState(props.order.status);
  const modalTitle = orderStatus === KnownOrderDtoStatus.Booked ? 'Deliver Now' : 'Retrieve Now';

  return (
    <Modal
      title={modalTitle}
      open={true}
      maxWidth="xs"
      loading={hook.isLoading}
      isEmptyWhenLoading
      onClose={props.onAbort}
    >
      <DeliverNowModalContent
        {...hook}
        order={props.order}
        confirmationStepSubHeading="Please confirm"
        showRecipientSummary
        showBookingConfirmationAlert={false}
      />
    </Modal>
  );
}
